module.exports = __webpack_public_path__ + "static/media/ans_logo_resized.9d48edab.png";